<template>
    <div>
        <CommonPopupFrame :changeBottom="0" :changeHeight="height" :changeHeightUnit="'px'" :isOpen="isShowBookmarkPopup" :closeCompleteAction="closeBookmarkPopup">
            <div class="main_wrapper">
                <slot></slot>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'

export default {
    name: 'CommonBookMarkPopup',
    components: { CommonPopupFrame },
    props: {
        isShowBookmarkPopup: {
            type: Boolean,
            default: false
        },
        closeBookmarkPopup: {
            type: Function,
            default: () => { }
        },
        height: {
            type: Number,
            default: 0
        }
    }
}
</script>

<style scoped>
.main_wrapper {
    flex: 1;
    background: linear-gradient(90deg, #FF7111 0%, #EABB56 50%, #FFC39A 100%);
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    padding: 20px;
    padding-top: 16px;
}
</style>